import script from "./TaskFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskFilter.vue?vue&type=script&setup=true&lang=js"

import "./TaskFilter.vue?vue&type=style&index=0&id=5e72a98b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e72a98b"]])

export default __exports__